export const showpadEvents = [
    { id: 'app-opened', name: 'Showpad Add - App Opened' },
    { id: 'channel-used', name: 'Showpad Add - Channel Used' },
    { id: 'experience-tracked-event', name: 'Showpad Add - Experience Triggered' },
    { id: 'asset-in-app-viewed', name: 'Assets - Viewed' },
    { id: 'asset-in-app-downloaded', name: 'Assets - Downloaded' },
    { id: 'asset-shared', name: 'Assets - Shared' },
    { id: 'asset-asset-viewed', name: 'Assets - Prospect Viewed' },
    { id: 'asset-asset-downloaded', name: 'Assets - Prospect Downloaded' },
    { id: 'share-viewed', name: 'Shares - Prospect Viewed' },
    { id: 'share-created', name: 'Shares - Created' },
    { id: 'share-email-opened', name: 'Shares - Email Opened' },
    { id: 'share-reshared', name: 'Shares - Prospect Forwarded' },
    { id: 'sharedspace-added-asset', name: 'Shared Space - Added Asset' },
    { id: 'sharedspace-added-comment', name: 'Shared Space - Participant Commented' },
    { id: 'sharedspace-created', name: 'Shared Space - Created' },
    { id: 'sharedspace-invited-participant', name: 'Shared Space - Participant Invited' },
    { id: 'sharedspace-joined', name: 'Shared Space - Invitee Joined' },
    { id: 'sharedspace-opened-invite', name: 'Shared Space - Invitee Opened Invite' },
    { id: 'sharedspace-removed-asset', name: 'Shared Space - Removed Asset' },
    { id: 'sharedspace-removed-comment', name: 'Shared Space - Removed Comment' },
    { id: 'sharedspace-revoked-access', name: 'Shared Space - Revoked Access' },
    { id: 'sharedspace-revoked-access-all', name: 'Shared Space - Revoked All Access' },
    { id: 'sharedspace-unrevoked-access', name: 'Shared Space - Undone Revoke Access' },
    { id: 'sharedspace-unrevoked-access-all', name: 'Shared Space - Undone Revoked All Access' },
    { id: 'sharedspace-viewed', name: 'Shared Space - Member Viewed' },
    { id: 'sharedspace-viewed-asset', name: 'Shared Space - Member Viewed Asset' },
];

export const showpadAssets = [
    { id: '3d-model', name: '3d-model' },
    { id: 'audio', name: 'audio' },
    { id: 'document', name: 'document' },
    { id: 'page', name: 'page' },
    { id: 'personal-video-recording', name: 'personal-video-recording' },
    { id: 'photo', name: 'photo' },
    { id: 'raw', name: 'raw' },
    { id: 'scorm', name: 'scorm' },
    { id: 'video', name: 'video' },
    { id: 'url', name: 'url' },
    { id: 'webapp', name: 'webapp' },
];
